<template>
	<div>
		<div class="fw7 fs5 lh150">Do you want to issue this proposal?</div>
		<div class="lh125">
			This Proposal will become an issued proposal. This action can't be
			reverted.
		</div>
		<div class="flex xs-12 xs-between xs-middle mt6">
			<j-button :isLoading="isLoading" @click="onIssue">
				Issue Proposal
			</j-button>
			<div class="flex xs-middle">
				<checkbox name="uploadFiles" id="uploadFiles" v-model="uploadFiles" />
				<p class="ml2">Save files to proposal</p>
				<j-spinner v-if="isLoading" :delay="50" />
			</div>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import { Checkbox } from "vue-checkbox-radio" //https://github.com/mariomka/vue-checkbox-radio
import axios from "axios"
import dayjs from "dayjs"

import api from "@/api/gql.js"
import JSpinner from "@/components/JSpinner"
import { gql } from "@/api/utils.js"

export default {
	components: { JButton, Checkbox, JSpinner },

	props: {
		policyId: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false,
			uploadFiles: false,
			// list of IDs of templates to fetch and upload on issuance
			templateIds: ["6bf9d7ab-b2f3-463d-9cb4-d2b19f5df42c"],
			// templat details of listed templateIds above
			filesToUpload: [],
			formDataList: []
		}
	},

	methods: {
		async onIssue() {
			if (this.uploadFiles) {
				await this.issueProposal()
				await this.downloadPdfFile()
				await this.uploadPdfFiles()
				this.$emit("done")
			} else {
				await this.issueProposal()
				this.$emit("done")
			}
		},

		async issueProposal() {
			const query = gql`
				mutation issueProposal($caseId: String!, $proposalId: String!) {
					issueProposal(caseId: $caseId, proposalId: $proposalId) {
						errors
						status
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					caseId: this.$store.state.caseManagement.caseId,
					proposalId: this.$store.state.caseManagement.proposalId
				}
			})
			this.isLoading = false

			// Check errors
			if (res?.data?.issueProposal?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.issueProposal?.errors?.[0] || this.$t("errors.general")
				)
				return
			}
		},

		async downloadPdfFile() {
			let apiKey = "renderPdfDrawingTemplate"

			// Query
			const query = `
				query ${apiKey}($templateId: String!, $input: templateRenderParametersInput){
					${apiKey}(templateId: $templateId input: $input) {
						errors
						status
						value
					}
				}
			`

			// download file for each templateId in filesToUpload
			await Promise.all(
				this.filesToUpload?.map(async item => {
					// Variables
					// Currency options
					// Get currency form contract currency which is a case.fact.currency
					const contractCurrency = this.$store.state.caseManagement?.case?.facts?.find(
						fact => fact.type === "currency"
					)?.value?.stringValue

					const currencyOptions = contractCurrency
						? { currencyCodes: [contractCurrency] }
						: { currencyCodes: [] }

					// Variables
					const {
						caseId,
						proposalId,
						offerId
					} = this.$store.state.caseManagement
					const variables = {
						templateId: item.id,
						input: {
							name: "data",
							variablesJsonString: JSON.stringify({
								caseWhere1: { id: caseId },
								proposalWhere1: { id: proposalId },
								offerWhere1: { id: offerId },
								currencyOptions
							})
						}
					}

					// Call
					this.isLoading = true
					const res = await api({ query, variables })
					this.isLoading = false

					let bytes = new Uint8Array(res.data?.[apiKey]?.value) // pass your byte response to this constructor
					const blob = new Blob([bytes], { type: "application/pdf" }) // change resultByte to bytes
					const formData = new FormData() // create formData to pass
					const currentDate = dayjs().format("YYYY-MM-DD")
					const uploadFileName = `${item.name}-${currentDate}.pdf`
					formData.append("file", blob, uploadFileName)

					// store each formData in formDataList array
					this.formDataList.push(formData)
				})
			)
		},

		async uploadPdfFiles() {
			const path = `proposals/${this.$store.state.caseManagement.proposalId}`

			await Promise.all(
				this.formDataList?.map(async formData => {
					await axios.post(
						`https://api.asia.covergo.com/api/v1/files/${encodeURIComponent(path)}`,
						formData,
						{
							headers: {
								Authorization: `Bearer ${window.TK}`,
								"Content-Type": "multipart/form-data"
							}
						}
					)
				})
			)
		},

		async fetchTemplates() {
			await Promise.all(
				this.templateIds?.map(async id => {
					const query = gql`
						query fetchTemplates(
							$where: templateWhereInput!
							$sort: sortInput
						) {
							templates(where: $where, sort: $sort) {
								totalCount
								list {
									id
									name
									createdAt
									lastModifiedAt
									__typename
								}
							}
						}
					`

					let variables = {
						where: { id: id },
						sort: { fieldName: "createdAt", type: "desc" }
					}

					const res = await api({ query, variables })
					const template = res?.data?.templates?.list?.map(item => ({
						name: item.name,
						id: item.id,
						typeName: item.__typename
					}))

					this.filesToUpload.push(...template)
				})
			)
		}
	},

	created() {
		this.fetchTemplates()
	}
}
</script>
